import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { GlobeIcon, CodeIcon, FlaskConicalIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function Projects() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-60px'
  });
  const {
    t
  } = useLanguage();
  const projects = [{
    icon: GlobeIcon,
    title: 'EU Digital Bridge',
    descKey: 'projects.p1.desc',
    statusKey: 'projects.p1.status',
    statusColor: '#10B981',
    tags: ['B2B', 'Експорт', 'Консалтинг']
  }, {
    icon: CodeIcon,
    title: 'Tech Talent Academy',
    descKey: 'projects.p2.desc',
    statusKey: 'projects.p2.status',
    statusColor: '#3B82F6',
    tags: ['Освіта', 'Сертифікація', 'HR']
  }, {
    icon: FlaskConicalIcon,
    title: 'Innovation Lab Budapest',
    descKey: 'projects.p3.desc',
    statusKey: 'projects.p3.status',
    statusColor: '#F59E0B',
    tags: ['R&D', 'Стартапи', 'Інфраструктура']
  }];
  return <section id="projects" ref={ref} className="relative w-full overflow-hidden px-4 py-16 sm:py-24" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-335">
      <div className="relative z-10 mx-auto max-w-7xl" data-id="element-336">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.4,
        ease: [0.25, 0.46, 0.45, 0.94]
      }} className="mb-12 sm:mb-16 text-center" data-id="element-337">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{
          color: 'var(--text-primary)'
        }} data-id="element-338">
            {t('projects.title')}
          </h2>
          <p className="text-lg max-w-2xl mx-auto" style={{
          color: 'var(--text-secondary)'
        }} data-id="element-339">
            {t('projects.desc')}
          </p>
        </motion.div>

        <div className="grid gap-6 lg:grid-cols-3" data-id="element-340">
          {projects.map((project, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 12
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.4,
          delay: 0.05 + index * 0.06,
          ease: [0.25, 0.46, 0.45, 0.94]
        }} data-id="element-341">
              <div className="h-full rounded-3xl border p-6 sm:p-8 flex flex-col relative" style={{
            borderColor: 'var(--border)',
            backgroundColor: 'var(--bg-secondary)'
          }} data-id="element-342">
                {/* Status Badge */}
                <div className="absolute top-6 right-6" data-id="element-343">
                  <span className="px-3 py-1 rounded-full text-xs font-bold" style={{
                backgroundColor: `${project.statusColor}15`,
                color: project.statusColor
              }} data-id="element-344">
                    {t(project.statusKey)}
                  </span>
                </div>

                <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-6" style={{
              backgroundColor: 'var(--bg-tertiary)'
            }} data-id="element-345">
                  <project.icon className="w-6 h-6" style={{
                color: 'var(--accent)'
              }} data-id="element-346" />
                </div>

                <h3 className="text-xl font-bold mb-3" style={{
              color: 'var(--text-primary)'
            }} data-id="element-347">
                  {project.title}
                </h3>

                <p className="text-base mb-8 flex-1" style={{
              color: 'var(--text-secondary)'
            }} data-id="element-348">
                  {t(project.descKey)}
                </p>

                <div className="flex flex-wrap gap-2 mt-auto pt-6 border-t" style={{
              borderColor: 'var(--border)'
            }} data-id="element-349">
                  {project.tags.map((tag, i) => <span key={i} className="px-2.5 py-1 rounded-md text-xs font-medium" style={{
                backgroundColor: 'var(--bg-tertiary)',
                color: 'var(--text-muted)'
              }} data-id="element-350">
                      {tag}
                    </span>)}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}